import { ProductRedemptionPinCharacteristicsInfoDto } from './../../product/redemption/pin-characteristics-info.dto';

export class ProductRedemptionDto {
  id: string;
  redemptionWebsite: string;
  redemptionManualEntryFormat: string;
  redemptionLocation: string[];
  redemptionMethod: string;
  redemptionHyperlinkExpression: string;
  redemptionDelay: number;
  pinCharacteristicsInfo: ProductRedemptionPinCharacteristicsInfoDto;

  constructor(d?: ProductRedemptionDto) {
    if (!d) {
      return;
    }

    this.id = d.id;
    this.redemptionWebsite = d.redemptionWebsite;
    this.redemptionManualEntryFormat = d.redemptionManualEntryFormat;
    this.redemptionLocation = d.redemptionLocation;
    this.redemptionMethod = d.redemptionMethod;
    this.redemptionHyperlinkExpression = d.redemptionHyperlinkExpression;
    this.redemptionDelay = d.redemptionDelay;
    this.pinCharacteristicsInfo = d.pinCharacteristicsInfo;
  }
}
